var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpensifyAppIcon = function SvgExpensifyAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "expensify-app-icon_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".expensify-app-icon_svg__st1{fill:#002e22}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03d47c"
    },
    d: "M0 0h48v48H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 18.5v-3.9H17.4v18.9h13.2v-3.9h-8.4V26H29v-4h-6.7v-3.4h8.3z",
    className: "expensify-app-icon_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.3c3.3 0 6.4 1 9 2.8.6.4 1.5.4 2.1-.1.6-.6.6-1.7-.1-2.2-3.1-2.2-6.9-3.5-11-3.5C13.7 5.3 5.3 13.7 5.3 24c0 4.1 1.3 7.9 3.5 10.9.5.7 1.6.8 2.2.1.6-.6.6-1.4.1-2.1-1.8-2.6-2.8-5.6-2.8-9 0-8.5 7.1-15.6 15.7-15.6zM39.5 13.4c-.5-.7-1.6-.8-2.2-.2-.6.6-.6 1.4-.2 2.1 1.6 2.5 2.6 5.5 2.6 8.7 0 3.2-1 6.3-2.7 8.8-.4.7-.4 1.5.2 2.1.6.6 1.7.6 2.2-.1 2.1-3 3.4-6.8 3.4-10.8 0-4-1.2-7.6-3.3-10.6zM24 39.7c-3.2 0-6.2-1-8.7-2.6-.7-.4-1.5-.4-2.1.2-.6.6-.6 1.7.2 2.2 3 2.1 6.7 3.3 10.6 3.3 3.9 0 7.7-1.3 10.8-3.4.7-.5.8-1.6.1-2.2-.6-.6-1.4-.6-2.1-.2-2.5 1.7-5.5 2.7-8.8 2.7z",
    className: "expensify-app-icon_svg__st1"
  })));
};
export default SvgExpensifyAppIcon;